// extracted by mini-css-extract-plugin
export default {"container":"ContactSection_container__B6Mc9","title":"ContactSection_title__3VYjS","contacts":"ContactSection_contacts__vhgug","copy":"ContactSection_copy__xqo3v"};